
import axios from 'axios'; 
import QS from 'qs' 
import store from '../store' //导入vuex状态块
import router from '../../router/'      //路由管理
import { message, Modal } from 'ant-design-vue'
//设置请求的根路径
axios.defaults.timeout = 5000;                        //响应时间
axios.defaults.headers.get['Content-Type']='application/x-www-form-urlencoded;charset=UTF-8';
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;application/json;charset=UTF-8';//配置请求头
// axios.defaults.headers.post['Content-Type'] = 'application/json; charset=UTF-8';//配置请求头
// axios.defaults.baseURL = 'http://localhost:5555';   //配置接口地址
axios.defaults.baseURL = 'https://api.oopvr.com:8080';   //配置接口地址
// Vue.http.options.root = "http://api.oopvr.com" 


axios.interceptors.request.use(


    config => {
        // 每次发送请求之前判断vuex中是否存在token        
        // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断 
            const token = store.state.index.token;
            token && (config.headers.oopvr = token);
            return config;

  
    },
    error => {
        return Promise.error(error);
    })

// 响应拦截器
axios.interceptors.response.use(
    response => {
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据     
        // 否则的话抛出错误
        if (response.status === 200) {
            
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是2开头的的情况
    // 这里可以跟你们的后台开发人员协商好统一的错误状态码    
    // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
    // 下面列举几个常见的操作，其他需求可自行扩展
    error => {
        if (error.response.status) {
            switch (error.response.status) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。                
                case 401:
                    console.log("401")
                    message.error('没有权限,请联系管理员',10)
                    // router.replace({
                    //     path: '/Login',
                    //     query: {
                    //         redirect: router.currentRoute.fullPath
                    //     }
                    // });
                    break;

                // 403 token过期
                // 登录过期对用户进行提示
                // 清除本地token和清空vuex中token对象
                // 跳转登录页面                
                case 403:
                    localStorage.removeItem('vuex-netUser');
                    store.commit('setStateUser', null);
                    window.localStorage.setItem('vuex-netUser','null')
                    store.commit("setNetUserState", false);
                    message.error('登录过期，请重新登录。',5)
                    // 清除token
                    // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面 
                    setTimeout(() => {
                        router.replace({
                            path: '/',
                        });
                    },1);
                    break;

                // 404请求不存在
                case 404:
                    message.error("网络请求异常",5)
                    break;
                // 其他错误，直接抛出错误提示
                default:
                    message.error("服务器错误"+error.response.status,5)
            }
            return Promise.reject(error.response);
        }
    })

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

export function get(url,  params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then(res => {
            if (res.data.code != 1) {
                return message.error(res.data.msg, 5);
              }
            resolve(res.data);
        }).catch(err => {
            reject(err.data)
        })
    });
}

/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url,QS.stringify(params))
        .then(res => {
            if (res.data.code != 1) {
                return message.error(res.data.msg, 5);
              }
            resolve(res.data);
        })
        .catch(err =>{
            reject(err.data)
        })
    });
}


export function postObject(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url,params)
        .then(res => {
            if (res.data.code != 1) {
                return message.error(res.data.msg, 5);
              }
            resolve(res.data);
        })
        .catch(err =>{
            reject(err.data)
        })
    });
}
// /**
//  * 
//  * @param {*} url 
//  * @param {*} params 
//  * @returns 
//  */
// export function uploadImg(url, params) {
//     return new Promise((resolve, reject) => {
//         axios.post(url,params)
//         .then(res => {
//             resolve(res.data);
//         })
//         .catch(err =>{
//             reject(err.data)
//         })
//     });
// }


// WEBPACK FOOTER //
// ./src/script/request/http.js